import AuthorizationLogin from './Login';

export default AuthorizationLogin;
